import dataApi from '../api/data'
import moment from 'moment'

export function cdnPrefix(value) {
  return '//official.cdn.qiyewan.com/' + value
}

export function totalPrice(checkout) {
  checkout.premium = checkout.premium >= 0
    ? checkout.premium
    : 0
  let _product = checkout.product;
  let member = (checkout.member - _product.minMember) >= 0
    ? (checkout.member - _product.minMember)
    : 0
  return (checkout.amount * _product.unitPrice + checkout.premium)
    .toFixed(2)
}

/**
 * 元旦活动(1.1 ~ 2.3) 计算总金额
 * @param checkout
 * @returns {*|string}
 */
export function totalPrice2(checkout) {
  checkout.premium = checkout.premium >= 0
    ? checkout.premium
    : 0
  let _product = checkout.product;

  if (['FC0001', 'FC0002', 'FC0003'].includes(_product.serialId.substr(4))) {
    return (checkout.amount * (_product.unitPrice - (_product.discountPrice || 0)) + checkout.premium).toFixed(2)
  }

  return (checkout.amount * (_product.unitPrice - (_product.discountPrice || 0)) + checkout.premium).toFixed(2)
}

export function dateFormat(timestamp) {
  let date = new Date(parseInt(timestamp))
  return date.getFullYear() + '/' + format(date.getMonth() + 1) + '/' + format(date.getDate()) + ' ' +
    (date.getHours() < 12 ? '上午' + date.getHours() : '下午' + (date.getHours() - 12)) +
    ':' + format(date.getMinutes()) + ':' + format(date.getSeconds())
}

/**
 * moment.js format time
 *  xx分钟\小时\天前
 *  3 天之内的 显示 fromNow 相对时间
 *  之外的 显示 绝对时间
 * @param date
 * @returns {*}
 */
export function dateFromNow(date) {
  if (moment().diff(date, 'days') <= 3) {
    return moment(date).fromNow()
  }
  // return moment(date).format('YYYY-MM-DD hh:mm:ss')
  return moment(date).format('YYYY-MM-DD')
}

export function regionFormat(regionCode) {
  let index = dataApi.regions.findIndex(item => item.code === regionCode)
  return index === -1 ? '上海' : dataApi.regions[index].name
}

export function zeroPriceTip(price) {
  return parseInt(price) === 0 ? '价格面议' : price
}

function format(num) {
  return num > 10 ? num : '0' + num
}



// WEBPACK FOOTER //
// ./src/filters/index.js